import { authorizedAxios } from 'library/axios/apiProvider';

export async function getSubscription() {
  const { data } = await authorizedAxios().get<any>(`/api/v1/subscription/`);
  return data;
}
